import { useFormContext } from 'react-hook-form'

import { ContactFormDto } from '@/domains/contact/application/dto/createContact.dto'
import { Input } from '@/ui/components/ui/input'
import { regexEmail } from '@/utils/regexEmail'
import PhoneInput from './phone'

export default function Form() {
  const {
    register,
    formState: { errors },
  } = useFormContext<ContactFormDto>()

  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-2 desktop:grid-cols-2">
      <div className="flex flex-col gap-1">
        <label htmlFor="name" className="field-label">
          Votre nom*
        </label>
        <Input
          id="name"
          {...register('name', { required: 'Ajoutez votre nom' })}
          type="text"
          placeholder="Nom"
          autoComplete="name"
          error={errors.name?.message as string}
          required
        />
        <div className="min-h-5 font-mono text-[0.6875rem] text-signal">
          {errors.name?.message}
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="email" className="field-label">
          Votre adresse email*
        </label>
        <Input
          id="email"
          {...register('email', {
            required: 'Ajoutez votre adresse email',
            pattern: regexEmail
              ? { value: regexEmail, message: 'Format incorrect' }
              : undefined,
          })}
          type="email"
          autoComplete="email"
          placeholder="Email"
          error={errors.email?.message as string}
          required
        />
        <div className="min-h-5 font-mono text-[0.6875rem] text-signal">
          {errors.email?.message}
        </div>
      </div>

      <PhoneInput
        label="Votre numéro de téléphone*"
        indicator="indicator"
        tel="phone"
        placeholder="0123456789"
        errorMessage="Ajoutez votre numéro de téléphone"
        className="desktop:col-span-2"
      />
    </div>
  )
}
